export const ActionsSearchBrandService = {
	GET_SEARCH_BRANDS_SERVICE: "get_search_brands_service",
	LOAD_GET_SEARCH_BRANDS_SERVICE: "load_get_search_brands_service",
	RES_GET_SEARCH_BRANDS_SERVICE: "res_get_search_brands_service",
	ERR_GET_SEARCH_BRANDS_SERVICE: "err_get_search_brands_service",
	HYDRATE: "HYDRATE",
};

export function failureSearchBrandService(err) {

	return {
		type: ActionsSearchBrandService.ERR_GET_SEARCH_BRANDS_SERVICE,
		err,
	};

}

export function loadSearchBrandService(params = {}) {

	return {
		type: ActionsSearchBrandService.GET_SEARCH_BRANDS_SERVICE,
		...params,
	};

}

export function loadGetSearchBrandService(params = {}) {

	return {
		type: ActionsSearchBrandService.LOAD_GET_SEARCH_BRANDS_SERVICE,
		...params,
	};

}

export function loadSearchBrandServiceSuccess(data) {

	return {
		type: ActionsSearchBrandService.RES_GET_SEARCH_BRANDS_SERVICE,
		data,
	};

}
